import type { Poll } from '@tunasong/schemas'

/**
 * A grouped poll — e.g. the best song on each album — is a many-of-many poll whose options belong to groups, each
 * with its own quota (absent means 1). Not a new pollType, for the same reason as the rehearsal poll.
 *
 * A fixed id is safe: group ids only need to be unique within one poll, and each poll gets its own copy.
 */
const template = {
  type: 'poll',
  name: 'Pick one per group',
  pollType: 'many-of-many',
  allowChange: true,
  pollGroups: [{ id: 'group-1', name: 'Group 1' }],
  pollOptions: [{ name: '', groupId: 'group-1' }],
} satisfies Poll

export default template
